import Quill from 'quill';

export type TipoDeAviso = 'info' | 'dica' | 'alerta' | 'perigo';

export const TIPOS_DE_AVISO: { value: TipoDeAviso; label: string }[] = [
  { value: 'info', label: 'Informação' },
  { value: 'dica', label: 'Dica' },
  { value: 'alerta', label: 'Atenção' },
  { value: 'perigo', label: 'Cuidado' },
];

const TIPOS = new Set<string>(TIPOS_DE_AVISO.map((tipo) => tipo.value));

export function tipoDoAviso(valor: unknown): TipoDeAviso {
  return typeof valor === 'string' && TIPOS.has(valor) ? (valor as TipoDeAviso) : 'info';
}

let registrado = false;

export function registrarAviso(): void {
  if (registrado) {
    return;
  }
  registrado = true;
  const Block = Quill.import('blots/block') as any;

  class Aviso extends Block {
    static blotName = 'aviso';
    static tagName = 'DIV';
    static className = 'aviso';

    static create(valor: unknown): HTMLElement {
      const no: HTMLElement = super.create(valor);
      no.classList.add(`aviso--${tipoDoAviso(valor)}`);
      return no;
    }

    static formats(no: HTMLElement): TipoDeAviso {
      const classe = Array.from(no.classList).find((atual) => atual.startsWith('aviso--'));
      return tipoDoAviso(classe?.slice('aviso--'.length));
    }
  }

  Quill.register(Aviso, true);
}
